<div mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  <span class="display-flex justify-content-between align-items-center">
    <h3 class="flex">Help</h3>
    <button mat-icon-button color="primary" aria-label="Close help" (click)="onClose()" tabindex="0">
      <mat-icon class="cursor-pointer">close</mat-icon>
    </button>
  </span>
</div>

<div mat-dialog-content [ngClass]="{ 'add-padding': canBrowse }" aria-describedby="Search for Help">
  <div class="help" [ngClass]="{ 'help-can-browse': canBrowse }">
    @if (canBrowse) {
      <aside class="help__search" role="complementary">
        <div class="help__search-input">
          <mat-form-field class="w-100">
            <mat-label>Search for Help</mat-label>
            <input
              matInput
              aria-label="Search for Help"
              type="text"
              placeholder="search term.."
              cdkFocusInitial
              [(ngModel)]="searchText"
              (keyup)="filterDictionary()"
            />
            <span matSuffix [hidden]="searchText.length === 0">
              <button aria-label="Delete Icon" mat-icon-button type="button" color="primary" (click)="clearSearch()" tabindex="0">
                <mat-icon>close</mat-icon>
              </button>
            </span>
          </mat-form-field>
        </div>
        <div class="help__search-container">
          @for (section of filteredResults; track section) {
            <ul class="help__search-list" [ngClass]="{ 'no-result': section.dictionary.length === 0 }">
              @if (section.dictionary.length > 0) {
                <h4 class="my-0 text-primary">
                  {{ section.title }}
                </h4>
                @for (term of section.dictionary; track term) {
                  <li class="help__search-item">
                    <p
                      class="my-0"
                      (click)="onSelectHelp(term)"
                      [ngClass]="{
                        'help__search-item--selected': term.label === selectedItem.label
                      }"
                      tabindex="0"
                      appKeyboardClick
                    >
                      {{ term.label }}
                    </p>
                  </li>
                }
              }
            </ul>
          }
        </div>
      </aside>
    }

    <div class="help__result" [ngClass]="{ 'help__result-can-browse': canBrowse }">
      @if (help && (selectedItem | json) !== "{}") {
        <mat-card appearance="outlined">
          <h3 class="help__result-title">
            {{ selectedItem.label }}
          </h3>
          @if (selectedDescriptorHtml) {
            <div class="help__descriptor" [innerHTML]="selectedDescriptorHtml"></div>
          }
          @if (selectedItem.iframeSource) {
            @if (!iFrameLoaded) {
              <div class="loading__container">
                <div class="loading"></div>
              </div>
            }
            <iframe
              [src]="sanitizeUrl(selectedItem.iframeSource)"
              class="iframe"
              frameborder="0"
              [ngClass]="{ 'display-none': !iFrameLoaded }"
            ></iframe>
          }
        </mat-card>
      }

      @if (nestedTerm) {
        <mat-card appearance="outlined">
          @if (area === helpArea.SpecialFactors) {
            <app-special-factors-expanded-text
              [search]="nestedTerm"
              [isIepAddendumActive]="isFeatureFlagActive"
            ></app-special-factors-expanded-text>
          }
          @if (area === helpArea.DomainsToBeEvaluated) {
            <app-fiie-consent-expanded-text></app-fiie-consent-expanded-text>
          }
        </mat-card>
      }

      @if ((selectedItem | json) === "{}" && !nestedTerm) {
        <mat-card appearance="outlined">
          <h3 class="help__result-title">Try searching for something!</h3>
          <p>There's no content here.</p>
        </mat-card>
      }
    </div>
  </div>
</div>

<div mat-dialog-actions class="display-flex justify-content-end align-items-center">
  <div class="display-flex my-2">
    <button mat-button aria-label="Close" class="background-color--muted" (click)="onClose()" tabindex="0">Close</button>
  </div>
</div>
